import { combineReducers } from 'redux-immutable';
import {reducre as psFormReducer} from '../components/psForm/store';



const defaultCombine = combineReducers({
  psform:psFormReducer
})

export default defaultCombine